var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSendMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 210,
  height: 210,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#sendMessage_svg__a)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 102.714,
  cy: 109,
  fill: "url(#sendMessage_svg__b)",
  rx: 66.731,
  ry: 66.633
}), /*#__PURE__*/React.createElement("path", {
  fill: "#464649",
  d: "M88.104 7.259c9.223-9.211 24.164-9.211 33.386 0l81.02 80.923c9.238 9.227 9.238 24.198 0 33.425l-80.898 80.802c-9.223 9.211-24.163 9.211-33.386 0l-81.02-80.923c-9.238-9.227-9.238-24.199 0-33.426z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m181.409 67.32 18.238 18.217L85.481 199.805l-18.238-18.217zM151.532 37.283 169.77 55.5 55.604 169.767 37.367 151.55zM122.13 7.935l18.239 18.216L26.203 140.42 7.964 122.202z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m140.953 182.847-18.249 18.228L8.178 86.924l18.25-18.228zM171.003 153.046l-18.249 18.228L38.228 57.123l18.25-18.228zM200.364 123.719l-18.25 18.227L67.588 27.796l18.25-18.229z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 104.289,
  cy: 183.142,
  fill: "#191919",
  opacity: 0.2,
  rx: 68.282,
  ry: 4.509
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144.227,
  cy: 67.77,
  r: 1.288,
  fill: "#7B8ECE"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#191919",
  fillRule: "evenodd",
  d: "m47.601 88.099 13.641 11.386.138.96-13.758-11.51s-1.309 20.844-1.309 33.267c0 8.293.584 22.536.971 31.091a7.86 7.86 0 0 0 7.438 7.519c10.78.576 32.324 1.558 53.996 1.558 21.678 0 43.357-.983 54.209-1.559a7.86 7.86 0 0 0 7.446-7.562c.359-8.918.909-24.13.909-33.539 0-13.958-1.211-30.776-1.211-30.776l-15.48 12.953.069-.99 15.334-12.799v-5.446a5 5 0 0 0-1.921-3.94l-11.226-8.776.291-4.116a4 4 0 0 0-3.991-4.281h-1.19v-9.12a6 6 0 0 0-6-6h-19.193l-14.423-11.275a6 6 0 0 0-7.403.009L90.603 46.419H72.927a6 6 0 0 0-6 6v6.688h-2.394a5 5 0 0 0-5 5v6.73l-10.021 7.876a5 5 0 0 0-1.91 3.93zm62.42 51.081h-2.349l1.175.982z",
  clipRule: "evenodd",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEA91B",
  fillRule: "evenodd",
  d: "m45.01 91.275 59.54 49.716 59.54-49.716v-5.237a5 5 0 0 0-1.92-3.938l-54.072-42.286a6 6 0 0 0-7.405.009L46.92 82.1a5 5 0 0 0-1.91 3.93z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5E5",
  fillRule: "evenodd",
  d: "M56.691 140.992V72.268a6 6 0 0 1 6-6h84.626a6 6 0 0 1 6 6v68.724z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2A2A2B",
  fillRule: "evenodd",
  d: "M61.845 119.09V70.268a4 4 0 0 1 4-4h79.607a4 4 0 0 1 4 4v48.822z",
  clipRule: "evenodd",
  opacity: 0.21
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M64.421 140.991V56.567a6 6 0 0 1 6-6h70.115a6 6 0 0 1 6 6v84.424z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("rect", {
  width: 20.613,
  height: 23.19,
  x: 74.656,
  y: 63.971,
  fill: "#FEA91B",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 37.362,
  height: 3.865,
  x: 100.535,
  y: 63.643,
  fill: "#191919",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 37.362,
  height: 3.865,
  x: 100.535,
  y: 72.662,
  fill: "#E5E5E5",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 37.362,
  height: 3.865,
  x: 100.535,
  y: 81.68,
  fill: "#E5E5E5",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 9.018,
  height: 3.865,
  x: 128.879,
  y: 81.68,
  fill: "#191919",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 64.417,
  height: 3.865,
  x: 73.48,
  y: 91.987,
  fill: "#191919",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 64.417,
  height: 3.865,
  x: 73.48,
  y: 101.005,
  fill: "#E5E5E5",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 64.417,
  height: 3.865,
  x: 73.48,
  y: 119.042,
  fill: "#E5E5E5",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 64.417,
  height: 3.865,
  x: 73.48,
  y: 128.06,
  fill: "#E5E5E5",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 42.515,
  height: 3.865,
  x: 73.48,
  y: 110.024,
  fill: "#E5E5E5",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 14.172,
  height: 3.865,
  x: 73.48,
  y: 110.024,
  fill: "#191919",
  rx: 1.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFC137",
  fillRule: "evenodd",
  d: "M45.01 91.275s-1.274 20.23-1.274 32.286c0 7.98.558 21.637.935 29.961a7.86 7.86 0 0 0 7.439 7.521c10.547.56 31.369 1.501 52.314 1.501 20.953 0 41.905-.941 52.522-1.502a7.86 7.86 0 0 0 7.446-7.561c.349-8.683.876-23.281.876-32.338 0-13.547-1.179-29.868-1.179-29.868L104.55 140.99z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEA91B",
  fillRule: "evenodd",
  d: "m91.256 129.891 10.541-7.07a5 5 0 0 1 5.525-.029l10.659 6.984 42.658 29.161s-.303.236-.46.348a10.27 10.27 0 0 1-5.431 1.901 934 934 0 0 1-50.323 1.358q-25.153 0-50.127-1.357a10.26 10.26 0 0 1-5.506-1.958 19 19 0 0 1-.647-.512z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M51.293 120.33v27.118M51.293 108.735v5.154M165.268 76.527l2.577-3.865M169.444 89.093l3.865 1.082M169.994 82.007l9.018-2.576"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "sendMessage_svg__b",
  x1: 118.483,
  x2: 37.331,
  y1: 19.19,
  y2: 98.201,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBEBEB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "sendMessage_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h210v210H0z"
})))));
export { SvgSendMessage as ReactComponent };
export default "data:image/svg+xml;base64,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";